import api from './../plugins/httpRequest'

const uri = "/api/feedbacks";

const apiGet = (params)=>{
    return api.get(uri,{params})
}

export default {
    namespaced: true,
    state: {
        list:[],
        total : 0,
        perPage : 0,
        page : 1,
        loading:true
    },
    mutations: {
        LIST(state, data) {
            state.loading = false
            state.list = data;

            let pageInfo = sessionStorage.getItem('pageInfo');
            if (pageInfo) {
                let [total,perPage,page] = pageInfo.split(",");
                state.total = parseInt(total);
                state.perPage = parseInt(perPage);
                state.page = parseInt(page);
            }
        }
    },
    actions: {
        get({commit,state},params) {
            state.loading = true;
            apiGet(params).then(function(res) {
                commit('LIST', res.data);
            },function() {
                state.loading = false;
            });
        }
    }
}
